<template>
  <div ref="chart" id="main" :style="{ width: width }"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chart",
  props: {
    preData: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: '375.5px'
    }
  },
  data() {
    return {
      chart: null,
      // 默认mock数据，确保图表能正确显示
      defaultData: [
        { product: '示例数据', 往年: 10, 今年: 15 }
      ]
    };
  },
  computed: {
    // 使用实际数据或默认数据
    currentData() {
      return this.preData && this.preData.length > 0 ? this.preData : this.defaultData;
    },
    chartPieOption() {
      return {
        color: ["#BAD9F7", "#349AFE"],
        legend: {
          show: true,
          data: ['往年', '今年']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.currentData.map(item => item.product),
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          name: '',
          min: 0,
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          }
        },
        series: [
          {
            name: '往年',
            type: "bar",
            data: this.currentData.map(item => item.往年),
            emphasis: {
              focus: 'series'
            }
          },
          {
            name: '今年',
            type: "bar",
            data: this.currentData.map(item => item.今年),
            emphasis: {
              focus: 'series'
            },
            label: {
              show: true,
              position: "top",
              fontSize: 18,
              color: "#0AC801",
              formatter: function (params) {
                // 获取对应的数据项
                const dataItem = this.currentData[params.dataIndex];
                let calculateData = "";
                if (dataItem["往年"] == 0 && dataItem["今年"] > 0) {
                  calculateData = "100%";
                } else if (dataItem["往年"] == 0 && dataItem["今年"] == 0) {
                  calculateData = "0%";
                } else {
                  calculateData = (((dataItem["今年"] - dataItem["往年"]) / dataItem["往年"]) * 100).toFixed(1).replace(/\.0$/, "") + "%";
                }
                return calculateData;
              }.bind(this)
            },
          },
        ],
      };
    },
  },
  components: {},
  watch: {
    chartPieOption: {
      handler(newValue) {
        // console.log('chartPieOption更新:', newValue);
        let myChart = echarts.getInstanceByDom(this.$refs.chart);
        if (myChart) {
          myChart.setOption(this.chartPieOption, true);
        }
      },
      deep: true
    },
    width: {
      handler() {
        // 宽度变化时重新调整图表大小
        let myChart = echarts.getInstanceByDom(this.$refs.chart);
        if (myChart) {
          myChart.resize();
        }
      }
    },
    preData: {
      handler(newData) {
        // console.log('preData更新:', newData);
        // 数据变化时重新设置选项
        let myChart = echarts.getInstanceByDom(this.$refs.chart);
        if (myChart) {
          myChart.setOption(this.chartPieOption, true);
        }
      },
      deep: true
    }
  },
  methods: {
    roundToOneDecimal(num) {
      return +num.toFixed(1).replace(/\.0$/, "");
    },
  },
  mounted() {
    // 调试日志，检查传入的数据
    // console.log('传入的preData:', this.preData);
    // console.log('实际使用的数据:', this.currentData);

    let myChart = echarts.getInstanceByDom(this.$refs.chart);
    if (myChart == null) {
      myChart = echarts.init(this.$refs.chart);
    }

    // 直接使用computed中的完整配置
    myChart.setOption(this.chartPieOption, true);

    // 添加窗口大小变化监听
    window.addEventListener('resize', () => {
      if (myChart) {
        myChart.resize();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
#main {
  width: 375.5px;
  /* 默认宽度，将被props覆盖 */
  height: 420px;
}
</style>
